export default __webpack_public_path__ + "static/media/wordswarmup_locked.77dac3fd.svg";